import { ReportProfileDelegateAccess } from '../../profile/report-profile-delegate-access';

export class MicrosoftReportProfileDelegate extends ReportProfileDelegateAccess {
  isAnonymousUser: boolean;
  isExternalUser: boolean;
  isApplication: boolean;
  foldersAccessed: string[];
}
